<!--
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-06-21 16:07:05
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-06-21 16:54:26
 * @FilePath: \xm-runing-main\src\layouts\default\header\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <Header :class="getHeaderClass">
    <!-- left start -->
    <div :class="`${prefixCls}-left`">
      <!-- logo -->
      <AppLogo
        v-if="appLogoFlag"
        :showLogo="showLogo||getShowHeaderLogo"
        :class="`${prefixCls}-logo`"
        :theme="getHeaderTheme"
        :showTitle="getShowSystemTitle!==false"
        :style="getLogoWidth"
      />
      <!--菜单展开 关闭-->
      <LayoutTrigger
        v-if="triggerMenuFlag!=false&&(getShowContent && getShowHeaderTrigger && !getSplit && !getIsMixSidebar)"
        :theme="getHeaderTheme"
        :sider="false"
      />
      <SpaceSelItem v-if="getShowSpaceSel&&isNotSystem" />
      <!-- 面包屑-->
      <LayoutBreadcrumb v-if="getShowContent && getShowBread" :theme="getHeaderTheme" />
    </div>
    <!-- left end -->

    <!-- menu start -->
    <div :class="`${prefixCls}-menu`" v-if="getShowTopMenu && !getIsMobile">
      <LayoutMenu
        :isHorizontal="true"
        :theme="getHeaderTheme"
        :splitType="getSplitType"
        :menuMode="getMenuMode"
      />
    </div>
    <!-- menu-end -->

    <!-- action  -->
    <div :class="`${prefixCls}-action`" style="padding-right: 16px;">
      <!--租户切换-->
      <XmTenantDropdown  v-if="isNotSystemOrGroup"/>
      <!--首页图标-->
      <GoHomeCoMponent />
      <!--邮件图标-->
<!--      <EmailIconComponent />-->
      <!--移动下载img-->
      <AppCalling :class="`${prefixCls}-action__item `" v-if="getShowCalling&&getUserFlag" />
      <!--移动下载img-->
      <AppDownImg :class="`${prefixCls}-action__item `" v-if="getShowApp" />
      <!--应用查询-->
      <AppSearch :class="`${prefixCls}-action__item `" v-if="getShowSearch" />

      <ErrorAction v-if="getUseErrorHandle" :class="`${prefixCls}-action__item error-action`" />

      <Notify v-if="getShowNotice" :class="`${prefixCls}-action__item notify-item`" />

      <FullScreen v-if="getShowFullScreen" :class="`${prefixCls}-action__item fullscreen-item`" />

      <AppLocalePicker
        v-if="getShowLocalePicker"
        :reload="true"
        :showText="false"
        :class="`${prefixCls}-action__item`"
      />

      <UserDropDown :theme="getHeaderTheme" />

      <SettingDrawer
        :settingLayout="settingLayout"
        v-if="getShowSetting && getUserDefLayout !== false"
        :class="`${prefixCls}-action__item`"
      />

      <UpdateLogIcon :class="`${prefixCls}-action__item`" />
      <xm-icon-help v-if="getShowHelp!==false" />
    </div>
  </Header>
</template>
<script lang="ts">
import { XmTenantDropdown } from '@/components/xm-tenant-and-industry-toggle'
  import { defineComponent, unref, computed, ref } from 'vue';

  import { propTypes } from '@/utils/propTypes';
  import XmIconHelp from '@/layouts/default/header/components/xm-icon-help.vue';
  import SpaceSelItem from '@/layouts/default/header/components/SpaceSelItem.vue';
  import { Layout } from 'ant-design-vue';
  import { AppLogo } from '@/components/Application';
  import LayoutMenu from '../menu/index.vue';
  import LayoutTrigger from '../trigger/index.vue';
  import { AppSearch } from '@/components/Application';
  import { useHeaderSetting } from '@/hooks/setting/useHeaderSetting';
  import { useMenuSetting } from '@/hooks/setting/useMenuSetting';
  import { useRootSetting } from '@/hooks/setting/useRootSetting';
  import {CurrentUtils} from 'xmgoing-server';
  import { MenuModeEnum, MenuSplitTyeEnum } from '@/enums/menuEnum';
  import { SettingButtonPositionEnum } from '@/enums/appEnum';
  import { AppLocalePicker } from '@/components/Application';

  import {
    AppCalling,
    AppDownImg,
    UserDropDown,
    LayoutBreadcrumb,
    FullScreen,
    Notify,
    ErrorAction,
    GoHomeCoMponent,
    EmailIconComponent,
    UpdateLogIcon,
  } from './components';
  import { useAppInject } from '@/hooks/web/useAppInject';
  import { useDesign } from '@/hooks/web/useDesign';

  import { createAsyncComponent } from '@/utils/factory/createAsyncComponent';
  import {useLocale} from '@/i18n/useLocale';
  import GoingUtils from "@/utils/goingUtils";
import {useIsOperateHook} from "@/hooks/useIsOperateHook";
import {StorageUtils} from "xmgoing-utils";
import {msgStore} from "@/store/modules/msgStore";

  export default defineComponent({
    name: 'LayoutHeader',
    components: {
      AppCalling,
      AppDownImg,
      XmIconHelp,
      XmTenantDropdown,
      SpaceSelItem,
      Header: Layout.Header,
      AppLogo,
      LayoutTrigger,
      LayoutBreadcrumb,
      LayoutMenu,
      UserDropDown,
      AppLocalePicker,
      FullScreen,
      Notify,
      AppSearch,
      ErrorAction,
      SettingDrawer: createAsyncComponent(() => import('@/layouts/default/setting/index.vue'), {
        loading: true,
      }),
      GoHomeCoMponent,
      EmailIconComponent,
      UpdateLogIcon,
    },
    props: {
      showLogo:{
        type:Boolean,
        default:true
      },
      triggerMenuFlag:{
        type:Boolean,
        default:true
      },
      appLogoFlag:{
        type:Boolean,
        default:true
      },
      settingLayout:{},
      fixed: propTypes.bool,
    },
    setup(props) {
      const { getUserDefLayout } = useRootSetting();
      const { prefixCls } = useDesign('layout-header');
      const store = msgStore()

      const {
        getShowTopMenu,
        getShowHeaderTrigger,
        getSplit,
        getIsMixMode,
        getMenuWidth,
        getIsMixSidebar,
      } = useMenuSetting();
      const { getUseErrorHandle, getShowSettingButton, getSettingButtonPosition } =
        useRootSetting();

      const {
        getIconColor,
        getShowSpaceSel,
        getHeaderTheme,
        getShowFullScreen,
        getShowHelp,
        getShowNotice,
        getShowContent,
        getShowSystemTitle,
        getShowBread,
        getShowHeaderLogo,
        getShowHeader,
        getShowSearch,
        getShowCalling,
        getShowApp,
        getEditoringFlag,
      } = useHeaderSetting();
      store.setNoticeFlag(unref(getShowNotice));
      const { getShowLocalePicker } = useLocale();

      const { getIsMobile } = useAppInject();

      const getHeaderClass = computed(() => {
        const theme = unref(getHeaderTheme);
        return [
          prefixCls,
          {
            [`${prefixCls}--fixed`]: props.fixed,
            [`${prefixCls}--mobile`]: unref(getIsMobile),
            [`${prefixCls}--${theme}`]: theme,
          },
        ];
      });

      const getShowSetting = computed(() => {
        if (!unref(getShowSettingButton)) {
          return false;
        }
        const settingButtonPosition = unref(getSettingButtonPosition);

        if (settingButtonPosition === SettingButtonPositionEnum.AUTO) {
          return unref(getShowHeader);
        }
        return settingButtonPosition === SettingButtonPositionEnum.HEADER;
      });

      const getLogoWidth = computed(() => {
        if (!unref(getIsMixMode) || unref(getIsMobile)) {
          return {};
        }
        const width = unref(getMenuWidth) < 180 ? 180 : unref(getMenuWidth);
        return { width: `${width}px` };
      });

      const getSplitType = computed(() => {
        return unref(getSplit) ? MenuSplitTyeEnum.TOP : MenuSplitTyeEnum.NONE;
      });

      const getMenuMode = computed(() => {
        // 头部菜单 / 混合顶部菜单都需要横向 mode，避免传 null 落到默认 inline
        if (unref(getShowTopMenu) || unref(getSplit)) {
          return MenuModeEnum.HORIZONTAL;
        }
        return null;
      });
      /**
       * 获取用户标志
       */
      const getUserFlag=computed(()=>{
        return CurrentUtils.getUserFlag();
      })

      const {isOerateUser}=useIsOperateHook();

      const isNotSystemOrGroup = computed(()=>{
          return GoingUtils.isNotSystemOrGroup()
      })

      const isNotSystem = computed(()=>{
        if(unref(isOerateUser)){
          return  false;
        }
        return !GoingUtils.isSystem(StorageUtils.getSessionItem("loginUserType"))
      })

      return {
        appLogoFlag:unref(props).appLogoFlag,
        getShowSystemTitle,
        getShowHelp,
        getIconColor,
        isNotSystem,
        isNotSystemOrGroup,
        getUserDefLayout,
        prefixCls,
        getHeaderClass,
        getShowHeaderLogo,
        getHeaderTheme,
        getShowSpaceSel,
        getShowHeaderTrigger,
        getIsMobile,
        getShowBread,
        getShowContent,
        getSplitType,
        getSplit,
        getMenuMode,
        getShowTopMenu,
        getShowLocalePicker,
        getShowFullScreen,
        getShowNotice,
        getUseErrorHandle,
        getLogoWidth,
        getIsMixSidebar,
        getShowSettingButton,
        getShowSetting,
        getShowSearch,
        getShowApp,
        getShowCalling,
        getEditoringFlag,
        getUserFlag,
      };
    },
  });
</script>
<style lang="less">
  @import './index.less';
</style>
